import { createContext, useContext, useMemo, useState } from "react";
import { defaultPeriodState, resolvePeriod } from "@/lib/period";

const PeriodContext = createContext(null);
const STORAGE_KEY = "minutepay_period_v1";

function loadState() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return defaultPeriodState();
    return { ...defaultPeriodState(), ...JSON.parse(raw) };
  } catch {
    return defaultPeriodState();
  }
}

export function PeriodProvider({ children }) {
  const [state, setState] = useState(loadState);

  const value = useMemo(() => {
    const period = resolvePeriod(state);
    return {
      state,
      period,
      setPreset(preset) {
        const next = { ...state, preset };
        setState(next);
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(next));
      },
      patch(partial) {
        const next = { ...state, ...partial };
        setState(next);
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(next));
      },
    };
  }, [state]);

  return <PeriodContext.Provider value={value}>{children}</PeriodContext.Provider>;
}

export function usePeriod() {
  const ctx = useContext(PeriodContext);
  if (!ctx) throw new Error("usePeriod must be used inside PeriodProvider");
  return ctx;
}
